import { FormRepository } from "../domain/FormRepository";

export class FormRepositoryGatsbyFunctions implements FormRepository {
  async send(formData: FormData): Promise<Response> {
    const body: { [key: string]: string | Blob } = {};
    for (const [key, value] of formData.entries()) {
      if (typeof value === "string") {
        body[key] = value;
      } else {
        body[key] = await readUploadedFile(value);
      }
    }
    return fetch(`/api/send-form`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  }
}

async function readUploadedFile(file: File): Promise<Blob> {
  return new Promise<Blob>((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(new Blob([reader.result as ArrayBuffer]));
    };
    reader.readAsArrayBuffer(file);
  });
}
